import { useState } from "react";

import { Card, ButtonGroup } from "react-bootstrap";

import ButtonComponent from "./ButtonComponent";

import formatUsername from "../utils/formatUsername";

import Channel from "../typings/Channel";
import SetState from "../typings/SetState";

import styled from "styled-components";

const ChannelCard = styled(Card)`
  box-shadow: 1px 4px 4px #aaaaaa;
  cursor: pointer;
  margin: 0.7rem 1.2rem;
  background-color: ${(props) => props.active};

  :hover {
    box-shadow: 1px 4px 10px grey;
  }

  .card-body {
    padding: 0.5rem;
  }

  .card-header {
    padding: 0.5rem;
  }
`;

const CardHeader = styled(Card.Header)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`;

const ChannelName = styled.div`
  font-weight: bold;
  font-size: 1.2rem;
  word-break: break-word;
`;

type ChannelComponentsProps = {
  channel: Channel;
  isActive: boolean;
  onClickChannelHandler: (channel: Channel) => void;
  setDeleteChannelModal: SetState<boolean>;
  setEditChannelModal: SetState<boolean>;
};

const ChannelComponent = ({
  channel,
  isActive,
  onClickChannelHandler,
  setDeleteChannelModal,
  setEditChannelModal,
}: ChannelComponentsProps) => {
  const [show, setShow] = useState(false);

  return (
    <ChannelCard
      data-testid={`channel-card-${channel.name}`}
      active={isActive ? "#e1e4e6" : undefined}
      onClick={() => onClickChannelHandler(channel)}
    >
      <CardHeader>
        <ChannelName>{channel.name}</ChannelName>
        <ButtonGroup size="sm">
          <ButtonComponent onClick={() => setDeleteChannelModal(true)}>
            <i className="fas fa-trash-alt"></i>
          </ButtonComponent>
          <ButtonComponent
            data-testid="edit-channel-button"
            onClick={() => setEditChannelModal(true)}
          >
            <i className="fas fa-edit"></i>
          </ButtonComponent>
        </ButtonGroup>
      </CardHeader>
      <Card.Body>
        <Card.Text>
          {channel.description ? channel.description : "No description"}
        </Card.Text>
        <Card.Text onClick={() => setShow((prev) => !prev)}>
          <i className={`fas fa-chevron-${show ? "down" : "right"}`}></i> See
          info
        </Card.Text>
        {show && (
          <>
            <Card.Text>
              <strong>Owners: </strong>
              {channel.owners
                .map((owner) => formatUsername(owner.username))
                .join(", ")}
            </Card.Text>
            <Card.Text>
              <strong>Subscribers - {channel.subscribers.length} : </strong>
              {channel.subscribers
                .map((subscriber) => formatUsername(subscriber.username))
                .join(", ")}
            </Card.Text>
          </>
        )}
      </Card.Body>
    </ChannelCard>
  );
};

export default ChannelComponent;
